import React, { useEffect, useState } from "react";

export default function LeaderboardModal({
  onClose,
  fetchLeaderboard,
  leaderboard = [],
}) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      if (typeof fetchLeaderboard === "function") {
        await fetchLeaderboard();
      } else {
        console.error("fetchLeaderboard prop is missing", fetchLeaderboard);
      }
      if (mounted) {
        setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const medals = ["🥇", "🥈", "🥉"];

  return (
    <div className="p-4 bg-blue-900">
      <h2 className="text-lg lg:text-xl font-bold text-cyan-200 mb-2 text-center">
        🏆 Leaderboard
      </h2>

      <div className="bg-blue-800 text-white rounded-3xl border border-gray-200">
        {loading ? (
          <div className="py-16 text-center">
            Loading...
          </div>
        ) : leaderboard.length === 0 ? (
          <div className="py-4 text-center">
            <div className="text-xl lg:text-2xl mb-3">🏅</div>
            <div className="font-semibold text-yellow-200">
              No leaderboard yet
            </div>
            <div className="text-sm text-gray-200 mt-2">
              Be the first player!
            </div>
          </div>
        ) : (
          <div className="px-3 py-1 space-y-1">
            {leaderboard.map((entry, i) => (
              <div
                key={entry.userId || i}
                className={`flex items-center gap-3 rounded-2xl px-4 py-3 border ${
                  i < 3
                    ? "bg-purple-900 border-yellow-300"
                    : "bg-blue-900 border-gray-200"
                }`}
              >

                <div className="w-10 text-center text-white font-bold">
                  {i < 3 ? medals[i] : `#${entry.rank}`}
                </div>
                <div className="w-11 h-11 rounded-full bg-[#7C3AED]/10 flex items-center justify-center text-[#7C3AED] font-bold">
                  {(entry.name || "?").charAt(0).toUpperCase()}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold truncate text-gray-100">
                    {entry.name}
                  </div>
                  <div className="text-xs text-gray-200">
                    {entry.userCode}
                  </div>
                  <div className="text-[11px] text-gray-300">
                    {entry.playDate}
                  </div>
                </div>

                <div className="text-right">
                  <div className="text-xl font-bold text-yellow-200">
                    {entry.score}
                  </div>
                  <div className="text-[11px] text-gray-300">
                    ⏱ {entry.timeTaken}s
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <button
        onClick={onClose}
        className="mt-2 w-fit px-6 py-2 bg-[#7C3AED] hover:bg-[#6D28D9] text-white font-semibold rounded-xl transition-colors"
      >
        Close
      </button>
    </div>
  );
}